import { createHash } from 'crypto';

export default class MD5 {
  static make(data: any): string {
    if (!data || (typeof data !== 'string' && !Buffer.isBuffer(data))) return '';
    return createHash('md5')
      .update(data)
      .digest('hex');
  }
}
